import DataModel from '../../library/proto/data-model'

/**
 * @param {Number} id 該Model的辨識索引
*/

export default class PaymentMethodsModel extends DataModel {
  constructor (args) {
    super(args)
    const entity = args || {}
    this.id = entity.id || 0
    this.sort = entity.sort || 0
    this.name = entity.name || ''
    this.content = entity.content || ''
    this.maintained_at = entity.maintained_at || ''
    this.finished_at = entity.finished_at || ''
    this.updated_user = entity.updated_user || ''
  }
}
